import { apiGet } from '@/lib/http/client';

import type { StripeConnectionsResponse } from '../types';

export async function getStripeConnections(
  orgId: number | string
): Promise<StripeConnectionsResponse> {
  return apiGet<StripeConnectionsResponse>(
    `/api/orgs/${orgId}/integrations/stripe/status/`,
    undefined,
    8000
  );
}
